import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { fromEnumAsString, toEnumFromStringOrNull } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export enum PointOfInterestTag {
    None = 'None',
    Bookable = 'Bookable',
    BuyTicket = 'BuyTicket',
    ContinuousPrograms = 'ContinuousPrograms',
    Fair = 'Fair',
    ForChildren = 'ForChildren',
    ForEveryone = 'ForEveryone',
    Party = 'Party',
    Workshop = 'Workshop'
}

export class PointOfInterestTagComponent extends Component {
  static readonly TYPE_ID: string = 'bb0b27495b6f4d228c52016fd7dc39a8';

  public readonly tag: PointOfInterestTag;

  constructor(
      tag: PointOfInterestTag | null = null,
  ) {
    super();

    this.tag = tag ?? PointOfInterestTag.None;
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return PointOfInterestTagComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PointOfInterestTagComponent {
    return new PointOfInterestTagComponent(
        toEnumFromStringOrNull(MapUtils.getOrNull(map, 'tag'), PointOfInterestTag),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'tag': fromEnumAsString(this.tag),
    };
  }

  clone(): this {
    return new PointOfInterestTagComponent(
        this.tag,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.tag === this.tag;
  }
}

export class PointOfInterestTagComponentBuilder extends DataModelBuilder<PointOfInterestTagComponent> {
  build(context: SerializationContext, map: SerializedData): PointOfInterestTagComponent {
    return PointOfInterestTagComponent.fromMap(context, map);
  }
}
